/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import getChoiceIconStyle from "assets/getChoiceIconStyle";

const B_minus = ({ isActive = false }) => {
  const fill = getChoiceIconStyle(isActive);
  return (
    <svg
      width="80"
      height="80"
      viewBox="10 10 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="80" height="80" fill="none" />
      <path
        d="M40.364 61.5C39.86 61.5 39.468 61.3693 39.188 61.108C38.9267 60.828 38.796 60.436 38.796 59.932V43.328C38.796 42.824 38.9267 42.4413 39.188 42.18C39.468 41.9 39.86 41.76 40.364 41.76H47.028C48.3907 41.76 49.548 41.9653 50.5 42.376C51.4707 42.7867 52.208 43.3747 52.712 44.14C53.2347 44.9053 53.496 45.8293 53.496 46.912C53.496 48.1067 53.1413 49.1147 52.432 49.936C51.7227 50.7573 50.7613 51.308 49.548 51.588V51.168C50.9293 51.3547 52.012 51.8773 52.796 52.736C53.58 53.576 53.972 54.6773 53.972 56.04C53.972 57.7947 53.3933 59.148 52.236 60.1C51.0787 61.0333 49.4547 61.5 47.364 61.5H40.364ZM41.596 59.26H47.028C48.428 59.26 49.464 58.9893 50.136 58.448C50.808 57.888 51.144 57.048 51.144 55.928C51.144 54.808 50.808 53.9773 50.136 53.436C49.464 52.8947 48.428 52.624 47.028 52.624H41.596V59.26ZM41.596 50.384H46.58C47.924 50.384 48.9413 50.1133 49.632 49.572C50.3227 49.0307 50.668 48.2373 50.668 47.192C50.668 46.1467 50.3227 45.3533 49.632 44.812C48.9413 44.2707 47.924 44 46.58 44H41.596V50.384ZM58.5533 55.172C58.2173 55.172 57.9373 55.06 57.7133 54.836C57.4893 54.612 57.3773 54.3413 57.3773 54.024C57.3773 53.688 57.4893 53.4173 57.7133 53.212C57.9373 52.988 58.2173 52.876 58.5533 52.876H64.7133C65.0306 52.876 65.3013 52.988 65.5253 53.212C65.7493 53.4173 65.8613 53.688 65.8613 54.024C65.8613 54.3413 65.7493 54.612 65.5253 54.836C65.3013 55.06 65.0306 55.172 64.7133 55.172H58.5533Z"
        fill={fill}
      />
    </svg>
  );
};

export default B_minus;
